import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// fetching data
import useFetch from "Hooks/useFetch";
import LoadingScreen from "Components/RequestHandler/LoadingScreen";
import IsError from "Components/RequestHandler/IsError";
import { useParams, useNavigate } from "react-router-dom";
import Container from "Components/Container/Container";
import ProductSlider from "./ProductSlider";
const ProductDetails = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData(`products/${slug}`);
      setData(data);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [slug]);

  if (isLoading) return <LoadingScreen />;
  if (error || isError) return <IsError />;
  if (data) {
    return (
      <main className="map">
        <section className="pt-32 lg:pt-60">
          <Container>
            <div className="text-xl text-[#808080] flex flex-wrap items-center gap-x-2 ">
              <Link to="/" className="hover:underline">
                Home
              </Link>
              <span>|</span>
              <Link
                onClick={() => navigate(-1)}
                className="capitalize hover:underline"
              >
                Products
              </Link>
              <span>|</span>
              <p className="capitalize">{data?.product_name}</p>
            </div>

            <h2 className="bebas text-white mt-2 text-4xl sm:text-5xl md:text-6xl lg:text-7xl ">
              {data?.product_name}
            </h2>
          </Container>
        </section>

        {/* landibg */}
        <section className="mb-secondary mt-10 lg:my-secondary map">
          <Container>
            <div className="flex flex-col lg:flex-row gap-y-4 gap-x-16">
              <div className="flex-1">
                <img
                  className="object-contain"
                  src={data?.product_image}
                  alt=""
                />
              </div>
              <div className="flex-1 flex flex-col gap-y-14">
                <span>
                  <h4 className="text-3xl text-white mb-4">Product Info</h4>

                  <div
                    className="text-white text-lg lg:pr-10"
                    dangerouslySetInnerHTML={{ __html: data?.product_info }}
                  />
                </span>
                {data?.product_series && (
                  <span>
                    <h4 className="text-3xl text-white mb-4">Product Series</h4>
                    <div
                      className="text-xl text-white custom-content"
                      dangerouslySetInnerHTML={{ __html: data?.product_series }}
                    />
                  </span>
                )}
                {data?.product_link && (
                  <span>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={data?.product_link}
                      className="hover:underline text-white hover:text-[#ccc] text-xl transition-all duration-200 e"
                    >
                      View Product Details
                    </a>
                  </span>
                )}

                <Link
                  to={"/request-form"}
                  state={{ name: data?.product_name }}
                  className="transition ease-in duration-300 hover:scale-[0.99] bg-[#555] hover:bg-[#333] text-white px-6 py-3 text-lg rounded-lg text-center block"
                >
                  Request a quote
                </Link>
              </div>
            </div>
          </Container>
        </section>

        <ProductSlider data={data?.otherProductSameCategory} />
      </main>
    );
  }
};

export default ProductDetails;
